import * as React from 'react';
import { Grid, Header, Message } from 'semantic-ui-react';
export var Maintenance = function () {
    React.useEffect(function () {
        document.title = 'Aplikace je nedostupná kvůli migraci – Market Intelligence Tool by COGVIO';
    }, []);
    return (<Grid data-testid='maintenance-screen' style={{ height: '100vh' }} textAlign='center' verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 480 }} textAlign='left'>
				<Header as='h2' style={{ color: '#3B7DDD', marginBottom: '1.5rem' }}>
					MIT by COGVIO
				</Header>
				<Header as='h1'>Aplikace je aktuálně nedostupná kvůli migraci</Header>
				<Message info>
					Předpokládaný výpadek je <strong>14:00–18:00</strong>.
				</Message>
			</Grid.Column>
		</Grid>);
};
Maintenance.displayName = 'Application.Maintenance';
